// NPM Imports
import React, { Fragment } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Label, Input, Tooltip } from "@revvsales/components";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";

const SignerListSection = ({
  signersList,
  showMenu,
  handlePhoneNumber,
  toggleCheckbox,
}) =>
  signersList && signersList.length > 0 ? (
    <Fragment>
      <div className="docsharingpopup-sharingform-title">
        These recipients will get an email with the document link where they can
        eSign.
      </div>
      <div className="recipientlistsection-signerlist recipientlistsection-signerlist-width">
        {signersList.map((signer, i) => (
          <div>
            <div className="recipientlistsection-row esign-auth-head">
              <div className="col-md-4 docsharingpopup-sharedusers-col">
                <div className="documentrecipientlist-userprofile-wrapper">
                  <div className="documentrecipientlist-profileimage-wrapper">
                    {signer.image_url && (
                      <img alt="Revv" src={signer.image_url} />
                    )}
                  </div>
                  <div className="documentrecipientlist-profile-wrapper">
                    <span className="documentrecipientlist-profile-name">
                      {signer.first_name || signer.last_name
                        ? `${signer.first_name} ${signer.last_name}`
                        : "-"}
                    </span>
                    <span className="documentrecipientlist-profile-email">
                      {signer.user_email ? signer.user_email : "-"}
                    </span>
                  </div>
                </div>
              </div>

              <div className="col-md-4 docsharingpopup-sharedusers-col documentrecipientlist-col">
                <span className="documentrecipientlist-role">
                  <FontAwesomeIcon
                    icon={["far", "signature"]}
                    className="documentrecipientlist-role-icon"
                  />
                  <span className="role-icon-mar">Signer</span>
                </span>
              </div>
              <div
                className="col-md-4 documentrecipient-user-cog documentrecipientlist-col"
                onClick={e => showMenu(e, i)}
                onKeyPress={() => {}}
                role="button"
                tabIndex="0">
                <span className="documentrecipient-user-cog">
                  <Tooltip
                    placement="top"
                    overlay="Enable SMS based eSign authentication for this recipient">
                    <FontAwesomeIcon
                      icon={["far", "user-cog"]}
                      className="documentrecipientlist-role-icon"
                    />
                  </Tooltip>
                </span>
                <span className="sign-auth">
                  <i
                    className={`ic-dropdown ${
                      signer.showAuth ? "dropdown-open" : ""
                    }`}>
                    <FontAwesomeIcon
                      icon={["far", "angle-down"]}
                      className="documentrecipientlist-role-icon"
                    />
                  </i>

                  {/* {showOptions && "hiiiii"} */}
                </span>
              </div>

              <div className="documentrecipientlist-oauth-wrapper">
                {signer.showAuth && (
                  <Fragment>
                    <div className="documentrecipientlist-otp-wrapper">
                      <div className="documentrecipientlist-userprofile-wrapper">
                        <div className="documentrecipientlist-profile-wrapper">
                          <span className="documentrecipientlist-profile-name">
                            <span className="documentrecipientlist-profile-email">
                              Authentication
                              <span className="sign-auth esign-authen-icon">
                                <Tooltip
                                  placement="bottom"
                                  overlay="When recipient initiates eSign process, they will get an OTP via SMS for identity authentication"
                                  align={{
                                    offset: [6, 0],
                                  }}>
                                  <FontAwesomeIcon
                                    icon={["far", "info-circle"]}
                                    className="documentrecipientlist-role-icon"
                                  />
                                </Tooltip>
                              </span>
                            </span>
                          </span>

                          <span className="documentrecipientlist-profile-email esign-show-otp">
                            <Input
                              data-test="confirmationbox-template-delete-checkbox-input"
                              type="checkbox"
                              value=""
                              checked={signer.showOtp}
                              onChange={() => toggleCheckbox(i)}
                            />
                            <Tooltip
                              placement="bottom"
                              overlay="When recipient initiates eSign process, they will get an OTP via SMS for identity authentication"
                              align={{
                                offset: [6, 0],
                              }}>
                              <Label
                                className="esign-authen-icon"
                                htmlFor="documentdelete-checkbox"
                                data-test="esignotp-checkbox-label">
                                Send OTP by SMS
                              </Label>
                            </Tooltip>
                          </span>
                        </div>
                      </div>
                    </div>

                    {signer.showOtp && signer.showAuth && (
                      <div className="documentrecipientlist-mobile-input-wrapper">
                        <Fragment>
                          <PhoneInput
                            data-test="esign-phone-number"
                            international
                            countryCallingCodeEditable={false}
                            defaultCountry="US"
                            value={
                              signer.mobile_number ? signer.mobile_number : ""
                            }
                            autoFocus
                            onChange={e => handlePhoneNumber(e, i)}
                          />
                          {!signer.isPossible && (
                            <div className="esign-number-error">
                              Please enter a valid phone number of recipient.
                            </div>
                          )}
                        </Fragment>
                      </div>
                    )}
                  </Fragment>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </Fragment>
  ) : null;
export default SignerListSection;



// WEBPACK FOOTER //
// ./src/components/DocumentApprovalPopupNew/AddRecipientsPopup/SignerListSection.js